module.exports = __webpack_public_path__ + "static/media/NYA-CAKE.42bcd95f.svg";